import React from "react";
import { Breadcrumb, Button, Modal, FormGroup, InputGroup } from "react-bootstrap";

const ModalWrapper = ({visible, onClose, modalTitle, modalSize, children, footerFlag=false, footerBody}) => {
    return(
        <Modal size={modalSize} show={visible}>
            <Modal.Header className="bg-dark text-white">
                <Modal.Title>{modalTitle}</Modal.Title>
                <Button variant="" className="btn btn-close text-white" onClick={onClose}>x</Button>
            </Modal.Header>
            <Modal.Body> {children} </Modal.Body>
            {footerFlag && <Modal.Footer>{footerBody}</Modal.Footer>}
        </Modal>
    );
};
export default ModalWrapper;